export const FETCH_ORDER_ACTION = "FETCH_ORDER"
export const FETCH_PROFILE_ACTION = "FETCH_PROFILE"
